import { Controller } from "@hotwired/stimulus"

// 필수 필드 유효성 검사 컨트롤러
// 모든 필수 필드가 입력되어 있을 때만 제출 버튼 활성화
export default class extends Controller {
  static targets = ["submit", "required", "requiredDisabled"]

  connect() {
    this.validateForm()
    // 폼 내 모든 input, select 변경 이벤트 감지
    this.element.addEventListener("input", this.validateForm.bind(this))
    this.element.addEventListener("change", this.validateForm.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("input", this.validateForm.bind(this))
    this.element.removeEventListener("change", this.validateForm.bind(this))
  }

  validateForm() {
    // 일반 필수 필드 검사 (disabled된 필드는 제외)
    const requiredValid = this.requiredTargets.every(target => {
      // disabled된 필드는 검사에서 제외 (중분류 dropdown/text input 전환 등)
      if (target.disabled) {
        return true
      }
      return target.value && target.value.trim() !== ""
    })

    // disabled 상태여도 값이 필요한 필드 검사 (주소 검색 등)
    const requiredDisabledValid = this.requiredDisabledTargets.every(target => {
      return target.value && target.value.trim() !== ""
    })

    const isValid = requiredValid && requiredDisabledValid

    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !isValid
      if (isValid) {
        this.submitTarget.classList.remove("opacity-50", "cursor-not-allowed")
      } else {
        this.submitTarget.classList.add("opacity-50", "cursor-not-allowed")
      }
    }
  }
}
